import React from 'react'
import classes from "./ZeroCard.module.scss"
import Button from 'components/Button'
import * as Icon from 'components/Icon';
import { useTranslation } from 'react-i18next';

const ZeroCard = ({ onClick }: {
  onClick?: () => void
}) => {
  const { t } = useTranslation()
  return (
    <div className={classes.wrapper}>
      <div className={classes.card}>
        <div className={classes.cardRight}>
          <h1>{t('start_business_without_any_lisenses')}</h1>
          <p>{t('start_business_without_any_lisenses_desc')}</p>
          <Button variant="white" suffixIcon={<Icon.System.ChevronRight />} onClick={onClick}>{t('more')}</Button>
        </div>
        <div className={classes.cardLeft}>
          <img src='/images/zero.svg' alt='zero' />
        </div>
      </div>
    </div>
  )
}

export default ZeroCard